import React, { FunctionComponent, useState, useEffect, Fragment } from 'react';
import {  Modal, Button, Container, Row, Col, Form, Alert, Spinner } from 'react-bootstrap';
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import PaymentConfirmation from './paymentConfirmation';
import PaymentSuccess from './paymentSuccess';
import FetchingSpinner from '../basicComponents/loaderModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { parseToCoin } from '../../services/AmountService';
import ObexToast from '../basicComponents/ObexToasts';
import AddCreditCard from './addCreditCard';

type SupportModalProps = {
  shown: boolean,
  onCloseAction: () => void,
  onSuccess: () => void
}

const SupportModal:FunctionComponent<SupportModalProps> = (props) => {
    
  const defaultSelectedPlan = { id: 0, monthly_price: 0, annual_price: 0, requests_number:0 } // Seteamos esto para por defecto no tener ninguno marcado
  const { shown, onCloseAction, onSuccess } = props;

  const [fetchingPlans, setFetchingPlans] = useState(false);
  const [supportPlans, setSupportPlans] = useState([]);
  const [supportPlanSelected, setSelectedPlan] = useState(defaultSelectedPlan);
  const [paymentEnable, setPaymentEnable] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [cards_, setCards] = useState([]);
  const [card_id_stripe, setCardID] = useState('');
  const [newadded_card, setAddedCard] = useState('');

  const getCards = async () => {
    try {
      const result = (await ObexRequestHandler.get('/cards', {}, true)).data || {};
      const { defaultCard, cards } = result;
      const pmCards = [];
      if (cards) {
        for (const c of cards) {
          const isDefault = c.id === defaultCard;
          c.defaultCard = isDefault;
          isDefault ? pmCards.unshift(c) : pmCards.push(c);
          if(cards_.some(e => e.id == c.id)){
            //console.log('exists');
          }else{
            setAddedCard(c.id);
          }
        }
      }
      setCards(pmCards);
  
    } catch (error) {
      console.error('ERROR FETCHING CARDS ', error);
      throw error;
    }
  }
  const handleModal = () => {
    setShowModal(!showModal);
    //onCloseAction();
    getCards();

  };
  

  const handleCard = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { value } = e.target;
    if (value=='addCard') {
      handleModal();
    } else {
      setCardID(value);

    }
    console.log(value);
    e.preventDefault();
    e.stopPropagation();
  
  }

  const getPlans = async () => {
    try {
      setFetchingPlans(true);
      const plans = (await ObexRequestHandler.get('/support_plans')).data;

      var ordered_plans = []
      ordered_plans = plans.sort((a, b) => a.id > b.id);


      setSupportPlans(ordered_plans);
    } catch (error) {
      console.error('ERROR FETCHING SUPPORT PLANS ', error);
      setError(error.message || error);
    }
    setFetchingPlans(false);
  }

  const startPayment = () => {
    setLoading(true);
    setSuccess('');
    setError('');
  }

  const gotoContact = () => {
    //history.push('https://www.101obex.com/#comp-jxad0a3m');
    window.open('https://www.101obex.com/#comp-jxad0a3m', "_blank")
  }
  const makePayment = async () => {
    try {
      startPayment();
      const payload = { supportPlanId: supportPlanSelected.id, card_stripe_id: card_id_stripe  };
      const result = await ObexRequestHandler.post('/support_plans', payload);
      const { success, message, data } = result;
      if (!success) throw { message };
      setSuccess(data);
      setPaymentSuccess(true);
      setPaymentEnable(false);
      onSuccess();
    } catch (error) {
      setError(error.message || error);
      console.error('ERROR BUYING EXTRA STORAGE ', error)
    }
    setLoading(false);
  }

  const removeSelectedPlan = () => setSelectedPlan(defaultSelectedPlan);

  // TODO MOSTRAR DECIMALES
  const supportPlansRows = supportPlans.map(r => (
    <Row className={'addon addons-border py-3 px-2 mb-4 position-relative' + (supportPlanSelected.id === r.id && ' addons-active')}>
    {supportPlanSelected.id === r.id && <FontAwesomeIcon icon={faCheck} />}
      <Col md="12" className="addons-title">
        <span>{r.title}</span>
      </Col>
      <Col>
        <Row>
          <Col md="6">
            <span>{r.description}</span>
          </Col>
          {r.id<3 &&
          <Col className="price-addons">
            <span>{`${parseToCoin(r.monthly_price)}/mo*`}</span>
          </Col>
          }
          {r.id<3 ?
          <Col>
            {supportPlanSelected.id === r.id ? 
              <Button value="5" className="custom-button-blue w-100 textBold btn-orange" onClick={removeSelectedPlan}>Remove</Button>:
              <Button value="5" className="custom-button-blue w-100 textBold" style={{ marginLeft: "auto" }} onClick={() => setSelectedPlan(r)}>Add</Button>
            }
          </Col>:
          <Col style={{display:'flex'}}>
          {supportPlanSelected.id === r.id ? 
            <Button value="5" className="custom-button-blue w-100 textBold btn-orange" onClick={removeSelectedPlan}>Remove</Button>:
            <Button value="5" className="custom-button-blue w-100 textBold" style={{ marginLeft: "auto", maxWidth:'200px', height:'34px' }} onClick={() => gotoContact()}>Contact Sales</Button>
          }
        </Col>
          }

        </Row>
      </Col>
    </Row>
  ))

  const selectPlanModalContent = (
    <Container fluid className="mh-100">
      {fetchingPlans ? <FetchingSpinner/> : supportPlansRows}
      <Row className="mb-2">
        <Col className="text-center" style={{display:'flex'}}>
          {supportPlanSelected.id > 0
            ? <Button style={{marginLeft:'30%', marginRight:'30%'}} className="custom-button-blue w-100 textBold" onClick={() => setPaymentEnable(true)}>Continue to Checkout</Button>
            : <Button style={{marginLeft:'30%', marginRight:'30%'}} className="custom-button-blue w-100 textBold btn-orange">Select an Option</Button>
          }
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <span>*Taxes and fees may apply</span>
        </Col>
      </Row>
    </Container>
  )
  useEffect(() => {
    getPlans();
    getCards();
  }, [])

  return(
    <Fragment>
      <Modal dialogClassName="addons-dialog themeDialog w-75 obex-dialog"
        show={shown} 
        onHide={onCloseAction}
        animation={false}>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="text-center w-100">
            <Row>
              <Col className="addons-title">
                <span>ISSUE360 Official Support</span>
              </Col>
            </Row>
            <Row>
              <Col md="10" className="mx-auto text-center modal-subtitle">
              {paymentEnable ?
              <span className="text-center d-block">Review your payment and proceed.</span>:
              <span className="text-center d-block">Choose your package and continue to checkout.</span>
              }
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {paymentEnable ? 
            <PaymentConfirmation
              actionSubmit={makePayment}
              handleGoBack={() => setPaymentEnable(false)}
              handleAnnualPayment={null}
              nameServiceSelected="Purchasing support."
              amountMonth={supportPlanSelected.monthly_price}
              amountYear={supportPlanSelected.annual_price}
              processingPayment={loading}
              success={success}
              error={error}
              isBlue={true}
              cards={cards_}
              handleCard={handleCard}
              addedCard={newadded_card}
              spanish={false}
            />
            : (paymentSuccess ? <PaymentSuccess blue={true} onCloseAction={onCloseAction} paymentDescription={''} paymentType={''}/> : selectPlanModalContent)
          }
        </Modal.Body>
      </Modal>  
      {showModal && <AddCreditCard show={showModal} handleClose={handleModal} isGreen={false} spanish={false}/>}  
      <ObexToast type='error' msg={error} clean={() => setError('')}/>
      <ObexToast type='success' msg={success} clean={() => setSuccess('')}/>              
    </Fragment>
  );
}

export default SupportModal;


